// export const isMobile = () => window.innerWidth <= 425;
// export const getDeviceType = () => {
//     return isMobile() ? 'mobile' : 'desktop';
// };

import { useMediaQuery } from '@chakra-ui/react';

export const useCheckForMobile = () => {
    const deviceType = useGetDeviceType();
    return deviceType === 'mobile';
};
export const useCheckForMobileOrTablet = () => {
    const deviceType = useGetDeviceType();
    return deviceType === 'mobile' || deviceType === 'tablet';
};
export const useCheckForTablet = () => {
    const deviceType = useGetDeviceType();
    return deviceType === 'tablet';
};
// export const isTablet = () =>
//     useMediaQuery('(min-width: 768px) and (max-width: 991px)')?.[0];
// export const isDesktop = () =>
//     useMediaQuery('(min-width: 992px) and (max-width: 1199px)')?.[0];
// export const isLargeMonitor = () =>
//     useMediaQuery('(min-width: 1200px) and (max-width: 1919px)')?.[0];
// export const isWideMonitor = () =>
//     useMediaQuery('(min-width: 1200px) and (max-width: 1919px)')?.[0];

export const useGetDeviceType = () => {
    const [isMobile, isTablet, isDesktop, isLargeMonitor] = useMediaQuery([
        '(max-width: 767px)',
        '(min-width: 768px) and (max-width: 1366px)',
        '(min-width: 1367px)',
    ]);
    try {
        if (isMobile) {
            return 'mobile';
        }
        if (isTablet) {
            return 'tablet';
        }
        if (isDesktop || isLargeMonitor) {
            return 'desktop';
        }
    } catch (error) {
        console.log(error);
        //return 'desktop';
    }
};
